import {useMemo} from 'react';
import lodashPickBy from 'lodash/pickBy';
import {ISSUE_ATTRIBUTE_NAMES} from '../constants/issue-attribute-names';
import i18n from './i18n';

export const useMappedInitialFieldValues = initialFieldValues =>
  useMemo(
    () =>
      initialFieldValues &&
      lodashPickBy(
        {
          [ISSUE_ATTRIBUTE_NAMES.TITLE]: initialFieldValues.title,
          [ISSUE_ATTRIBUTE_NAMES.LOCATION_ID]: initialFieldValues.lbsLocationId,
          [ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO]: initialFieldValues.assignedToId,
          [ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO_TYPE]: initialFieldValues.assignedToType,
          [ISSUE_ATTRIBUTE_NAMES.OWNER_ID]: initialFieldValues.ownerId,
          [ISSUE_ATTRIBUTE_NAMES.DESCRIPTION]: initialFieldValues.description,
          [ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID]: initialFieldValues.rootCauseId,
          [ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID]: initialFieldValues.subtypeId
        },
        value => typeof value !== 'undefined'
      ),
    [initialFieldValues]
  );
export const formatStatusOptions = statusOptions =>
  statusOptions.map(status => ({
    value: status,
    label: i18n.t(`status.${status}`),
    status
  }));
